import { Chip, Grid, Stack, Tooltip } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { LoadingWidget } from '../../../../widgets';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import { allNivelesAcademicosAction } from '../NivelesAcademicosAction';

export const tiposNivelAcademicoArray = [
  'EDUCACION INICIAL',
  'EDUCACION BASICA',
  'EDUCACION MEDIA TECNICA',
  'EDUCACION JOVENES ADULTOS',
  'EDUCACION SUPERIOR',
];

const ListadoNivelesAcademicos = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const nivelesAcademicosStore = Redux.useSelector(
    (state) => state.nivelesAcademicos,
  );

  // const [loadingDelete, setLoadingDelete] = React.useState(false);
  // const [isDelete, setIsDelete] = React.useState(false);

  React.useEffect(() => {
    async function fecthData() {
      if (
        nivelesAcademicosStore.all &&
        nivelesAcademicosStore.all.length === 0
      ) {
        await allNivelesAcademicosAction(
          dispatch,
          nivelesAcademicosStore.params,
        );
      }
    }
    fecthData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const _handleEditClick = async (id) => {
  //   const data = nivelesAcademicosStore.all.find((el) => el.id === id);
  //   await setActivoNivelesAcademicosAction(dispatch, data);
  //   setOpenModalForm(true);
  // };

  // const _handleDeleteClick = async () => {
  //   setLoadingEditar(true);
  //   await deleteNivelesAcademicosAction({dispatch, notify}, id, entidadesStore.activo.id);
  //   setIsDelete(false);
  //   setLoadingEditar(false);
  // };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.numero.name,
      label: CONST.numero.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
            // onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.abrev.name,
      label: CONST.abrev.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value.nombre}
                size="small"
                color={value.id === 1 ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              {/* <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={async () => {
                  const data = nivelesAcademicosStore.all.find(
                    (el) => el.id === tableMeta.rowData[0]
                  );
                  await setActivoNivelesAcademicosAction(dispatch, data);
                  setIsDelete(true);
                }}
                onDownload={() => {
                  const data = nivelesAcademicosStore.all.find(
                    (el) => el.id === tableMeta.rowData[0]
                  );
                  window.open(data.url);
                }}
              /> */}
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },

    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget isLoading={nivelesAcademicosStore.loadingAll} />
        <MUIDataTable
          title={'Listado'}
          data={nivelesAcademicosStore.all}
          columns={columns}
          options={options}
        />
      </Grid>
    </Grid>
  );
};

export default ListadoNivelesAcademicos;
